export const MESSAGE_VARIABLES = {
  cashback_used: "Rewards used",
  cashback: "Rewards",
};
